var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconQuestion = function SvgIconQuestion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16Zm-.554-4.988h1.348v-.703c0-.24.03-.435.088-.586.102-.269.469-.694 1.098-1.275a7.36 7.36 0 0 0 .733-.747c.513-.59.769-1.235.769-1.933 0-.43-.076-.826-.227-1.187l-.242-.454c-.556-.83-1.465-1.245-2.724-1.245-.2 0-.396.012-.586.036-.899.103-1.575.445-2.03 1.026C5.226 4.524 5 5.343 5 6.397h1.274c0-.64.086-1.13.257-1.472.298-.58.857-.871 1.677-.871.19 0 .371.02.542.058l.461.154c.61.298.916.798.916 1.502-.01.659-.383 1.318-1.12 1.977-.172.151-.291.256-.36.315a7.888 7.888 0 0 0-.783.828c-.279.366-.418.8-.418 1.303v.82ZM8.794 14v-1.56H7.446V14h1.348Z",
    fill: "#C2C3FF"
  })));
};
export default SvgIconQuestion;